import { render, staticRenderFns } from "./StoresMovement.vue?vue&type=template&id=22e1edcc&scoped=true&"
import script from "./StoresMovement.vue?vue&type=script&lang=js&"
export * from "./StoresMovement.vue?vue&type=script&lang=js&"
import style0 from "./StoresMovement.vue?vue&type=style&index=0&id=22e1edcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1edcc",
  null
  
)

export default component.exports